import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Inspection, InspectionSection } from '../../shared/models/index';

@Component({
    selector: 'inspection-detail',
    templateUrl: './detail.component.html',
    standalone: false
})
export class InspectionDetailComponent implements OnInit {
  @Input() public inspection: Inspection;
  @Output() public toggleSelectSection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleOpenSection: EventEmitter<any> = new EventEmitter();
  orderByFieldName = 'order';
  direction = 'asc';
  private isEditRoute = false;
  @Input() query: string = '';
  errorMessage: string;
  public selectable: boolean = true;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.url.subscribe((urlPaths) => {
      this.isEditRoute = urlPaths[0] && urlPaths[0].path === 'edit';
    });
  }

  public selectSection(e: any, section: InspectionSection) {
    e.stopPropagation();
    this.toggleSelectSection.emit(section);
  }

  public openSection(section: InspectionSection) {
    this.toggleOpenSection.emit(section);
  }

  public editRouteFor(id: string) {
    return ['inspectionbrowser/inspections', id, this.isEditRoute ? '' : 'edit'];
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
